/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DigitizingserviceMelcoModelsCustomWarning,
    DigitizingserviceMelcoModelsCustomWarningFromJSON,
    DigitizingserviceMelcoModelsCustomWarningFromJSONTyped,
    DigitizingserviceMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsOrderAlertSubmitResponse
 */
export interface DigitizingserviceMelcoDigitizingModelsOrderAlertSubmitResponse {
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderAlertSubmitResponse
     */
    message?: string | null;
    /**
     * 
     * @type {Array<DigitizingserviceMelcoModelsCustomWarning>}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderAlertSubmitResponse
     */
    warning_list?: Array<DigitizingserviceMelcoModelsCustomWarning> | null;
}

export function DigitizingserviceMelcoDigitizingModelsOrderAlertSubmitResponseFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsOrderAlertSubmitResponse {
    return DigitizingserviceMelcoDigitizingModelsOrderAlertSubmitResponseFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsOrderAlertSubmitResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsOrderAlertSubmitResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(DigitizingserviceMelcoModelsCustomWarningFromJSON)),
    };
}

export function DigitizingserviceMelcoDigitizingModelsOrderAlertSubmitResponseToJSON(value?: DigitizingserviceMelcoDigitizingModelsOrderAlertSubmitResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(DigitizingserviceMelcoModelsCustomWarningToJSON)),
    };
}


